import type { StateCreator } from 'zustand';
import { isabelApi } from '@/API/modules/isabelApi';
import { convertKeys } from '@/utils/common';
import type { IIsabelSurveySlice } from './types';

export const isabelSurveySlice: StateCreator<
  IIsabelSurveySlice,
  [],
  [],
  IIsabelSurveySlice
> = (set) => ({
  isabelSymptoms: [],
  isLoading: false,
  isabelTriageData: null,

  fetchIsabelSymptoms: async () => {
    set({ isLoading: true });

    try {
      const res = await isabelApi.getPredictiveText();
      const payload = res.data?.data;

      set({
        isabelSymptoms: payload?.predictive_text ?? [],
        isLoading: false,
      });
    } catch (e) {
      console.error(e);
      set({ isLoading: false });
    }
  },

  postDiagnoses: async (body) => {
    try {
      const res = await isabelApi.postDiagnoses(convertKeys(body, 'snake'));
      return convertKeys(res.data.data);
    } catch (e) {
      console.error(e);
    }
  },

  postTriage: async (body) => {
    try {
      const res = await isabelApi.postTriage(convertKeys(body, 'snake'));
      return convertKeys(res.data.data);
    } catch (e) {
      console.error(e);
    }
  },

  setIsabelTriageData: (data) => {
    set({ isabelTriageData: data });
  },

  clearIsabelTriage: () => {
    set({ isabelTriageData: null });
  },
});
